import { ApiHandler } from "./ApiHandler";

const DataFetching = async (
    setPending,
    url,
    method,
    token,
    dispatch,
    navigate,
    setFilteredData,
    setTotalPages,
    body,
    setResetSearch,
    resetSearch,
) => {
    setPending(true);
    try {
        const result = await ApiHandler(url, method, body, token, dispatch, navigate);
        if (result.data.status === "1") {
            if (result.data.status === "1" && result.data !== null) {
                setFilteredData(result?.data.data);
                setTotalPages(result?.data.total_record);
            } else {
                setFilteredData([]);
            }
        } else {
            setFilteredData([]);
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setPending(false);
        if (resetSearch) {
            setResetSearch(false);
        }
    }
};

export default DataFetching;
